[
    {
      "Name": "Drafting / Engineering",
      "Description": "Merge Two Plans Together",
      "Type": "O",
      "AID": 24440,
      "CategoryID": 21,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 5500,
          "AID": 24440,
          "APID": 47412,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Foundation ",
      "Description": "Additional Foundation ",
      "Type": "O",
      "AID": 24442,
      "CategoryID": 22,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24442,
          "APID": 47263,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Foundation ",
      "Description": "Pump Truck ",
      "Type": "O",
      "AID": 24443,
      "CategoryID": 22,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 800,
          "AID": 24443,
          "APID": 47264,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Foundation ",
      "Description": "Exterior Crawl Access | Opening 38 Inches | Requires Minimum 3' Foundation",
      "Type": "O",
      "AID": 24444,
      "CategoryID": 22,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 750,
          "AID": 24444,
          "APID": 47265,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Foundation",
      "Description": "6\" x  24-30\" Stem Wall w/ Hung Floor Joists | Rebar per code",
      "Type": "S",
      "AID": 24446,
      "CategoryID": 22,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Foundation",
      "Description": "12\" x 8\" Exterior & Interior Footing | Rebar per Code",
      "Type": "S",
      "AID": 24450,
      "CategoryID": 22,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Foundation",
      "Description": "Crawl Space Ground Cover: 6 mil. Black Poly | Additional Foundation Charged Accordingly",
      "Type": "S",
      "AID": 24452,
      "CategoryID": 22,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Foundation",
      "Description": "Ventilation: 8\" x 16\" Foundation Vents | Quantity Determined by Code",
      "Type": "S",
      "AID": 24453,
      "CategoryID": 22,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "2x Treated Sill Plate w/Connections Per Code |Sill Seal Moisture Barrier",
      "Type": "S",
      "AID": 24454,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Floor Joists: 9.5\" Manufactured \"I\" Joists, Spaced 19.2\" OC | Hung from Foundation Wall",
      "Type": "S",
      "AID": 24455,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Floor Sheathing: 3/4\" Engineered Weather Resistant T&G OSB | Nailed and Glued",
      "Type": "S",
      "AID": 24456,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Exterior Wall Framing: KD Douglas Fir Lumber 2x6 Studs Framed 16\" OC |92-5/8\" on 8' walls, 104-5/8\" on 9' walls | Single Bottom Plate | Double Top Plates",
      "Type": "S",
      "AID": 24457,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Signature Series Interior Wall Framing: KD Douglas Fir Lumber 2x4 Studs Framed 16\" OC | 92-5/8\" on 8' Walls | Some Structural and Plumbing Walls 2x6 |Single Bottom Plate | Double Top Plates",
      "Type": "S",
      "AID": 24458,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Wall Sheathing: 7/16 Weather Resistant OSB Wall Sheathing Creating \"Double Wall Construction\" (Studs, Sheathed, House-wrapped, then Sided)",
      "Type": "S",
      "AID": 24459,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Structural Features",
      "Description": "Headers: Fully Insulated Glu-Lam Beams",
      "Type": "S",
      "AID": 24460,
      "CategoryID": 23,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Sructural Features ",
      "Description": "9' Ceiling Height | First Floor Only | Second Floor at Standard Height Where Applicable",
      "Type": "O",
      "AID": 24463,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 4500,
          "AID": 24463,
          "APID": 47252,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2023-04-04T17:45:33.010Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Living Room ",
      "Type": "O",
      "AID": 24464,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24464,
          "APID": 47289,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Media Room ",
      "Type": "O",
      "AID": 24465,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24465,
          "APID": 47290,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Family Room ",
      "Type": "O",
      "AID": 24466,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24466,
          "APID": 47291,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Master Bedroom ",
      "Type": "O",
      "AID": 24467,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24467,
          "APID": 47292,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Extra Bedroom ",
      "Type": "O",
      "AID": 24468,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24468,
          "APID": 47293,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Bonus Room ",
      "Type": "O",
      "AID": 24469,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24469,
          "APID": 47294,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Den",
      "Type": "O",
      "AID": 24470,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24470,
          "APID": 47295,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Structural Features ",
      "Description": "Vaulted Dining Room ",
      "Type": "O",
      "AID": 24471,
      "CategoryID": 23,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24471,
          "APID": 47296,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Trusses",
      "Description": "Raised Heel Energy Truss Allowing Full Depth Insulation Over Top Plates | 24\" OC| 7/16\" OSB Roof Sheathing (or equal)",
      "Type": "S",
      "AID": 24476,
      "CategoryID": 24,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Trusses",
      "Description": "6/12 Truss Pitch (Or Pitch Per Plan) | 12\" Overhangs at Gable Ends | 16\" Overhang at Eaves",
      "Type": "S",
      "AID": 24477,
      "CategoryID": 24,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Trusses",
      "Description": "Trusses Engineered up to 40# Snow Load Standard",
      "Type": "S",
      "AID": 24478,
      "CategoryID": 24,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Attached Garage",
      "Description": "Garage Structure: KD Douglas Fir 2x6 Exterior Walls | Typical Trussed Ceiling (no storage)",
      "Type": "S",
      "AID": 24479,
      "CategoryID": 25,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Attached Garage",
      "Description": "Garage Slab: 4\" Concrete Slab | Control Lines |No Rebar or Fibermesh| No Fill or Prep Included",
      "Type": "S",
      "AID": 24481,
      "CategoryID": 25,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Attached Garage",
      "Description": "Garage Electrical /Lighting: (1) 110 Outlet per wall | (1) Over-Head Shop Light Per Bay",
      "Type": "S",
      "AID": 24482,
      "CategoryID": 25,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Attached Garage",
      "Description": "Garage Drywall / Insulation: Insulated | Sheetrocked and Fire Taped",
      "Type": "S",
      "AID": 24483,
      "CategoryID": 25,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Attached Garage ",
      "Description": "Garage Mandoor",
      "Type": "O",
      "AID": 24487,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 790,
          "AID": 24487,
          "APID": 47269,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Dead Bolts Locks | Price Per Each",
      "Type": "O",
      "AID": 24488,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 150,
          "AID": 24488,
          "APID": 47270,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Third Bay Garage | 12' x 2' Shorter than Standard Garage, Includes 9' x 7' Garage Door",
      "Type": "O",
      "AID": 24490,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 13500,
          "AID": 24490,
          "APID": 47272,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2023-03-28T22:23:03.193Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Move 16' x 7' Garage Door",
      "Type": "O",
      "AID": 24491,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 750,
          "AID": 24491,
          "APID": 47273,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "8' Garage Door in Place of Standard 7' Garage Door ",
      "Type": "O",
      "AID": 24492,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1000,
          "AID": 24492,
          "APID": 47274,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Garage Door Hardware Package ",
      "Type": "O",
      "AID": 24496,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 300,
          "AID": 24496,
          "APID": 47278,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "4' x 4' Garage Window ",
      "Type": "O",
      "AID": 24497,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 550,
          "AID": 24497,
          "APID": 47279,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Man Door Installed in Garage with Exterior Light",
      "Type": "O",
      "AID": 24500,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1100,
          "AID": 24500,
          "APID": 47282,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage ",
      "Description": "Wireless Key Pad ",
      "Type": "O",
      "AID": 24505,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 60,
          "AID": 24505,
          "APID": 47287,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Attached Garage",
      "Description": "Add RV Bay | Includes Man Door, RV Garage Door with Opener, Power, and Sheetrock ",
      "Type": "O",
      "AID": 24507,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 85,
          "AID": 24507,
          "APID": 47413,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2023-07-24T16:18:15.776Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Attached Garage",
      "Description": "Additional Garage Square Footage | Treasure Valley",
      "Type": "O",
      "AID": 24509,
      "CategoryID": 25,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 65,
          "AID": 24509,
          "APID": 47408,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Attached Garage",
      "Description": "Garage Door: 7' Tall White | Insulated | Metal Garage Door(s) | Top Row Windows | (2) Garage Door Opener Remotes w/ a Key Pad Entry | Door Width Varies Per Plan",
      "Type": "S",
      "AID": 26595,
      "CategoryID": 25,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Roofing",
      "Description": "Ridge Vents Installed ",
      "Type": "O",
      "AID": 24511,
      "CategoryID": 26,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 600,
          "AID": 24511,
          "APID": 47341,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Roofing",
      "Description": "Power Gable Vent (Moisture Control)",
      "Type": "O",
      "AID": 24512,
      "CategoryID": 26,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 550,
          "AID": 24512,
          "APID": 47342,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Roofing",
      "Description": "Metal Roofing | Up to 2000 Square Foot",
      "Type": "O",
      "AID": 24514,
      "CategoryID": 26,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 16000,
          "AID": 24514,
          "APID": 47346,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Roofing",
      "Description": "Owens Corning Duration Shingle with Sure Nail Strip | 130 MPH 50yr Arch Comp W/10 Year Limited Workmanship Warranty",
      "Type": "S",
      "AID": 24516,
      "CategoryID": 26,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Roofing",
      "Description": "High Performance Synthetic Underlayment | Metal Drip Edge | Continuous Ridge Venting when applicable",
      "Type": "S",
      "AID": 24517,
      "CategoryID": 26,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Roofing",
      "Description": "Gutters are not included in the base home",
      "Type": "S",
      "AID": 26596,
      "CategoryID": 26,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor living Area",
      "Description": "Included Porch Cover Varied Per Plan | See Lexar Base Plan for Included Size",
      "Type": "S",
      "AID": 24518,
      "CategoryID": 27,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Porch Covers | Outdoor living Area",
      "Description": "Soffit: LP Wood Faced Soffit with 1x Trim Over Joints",
      "Type": "S",
      "AID": 24519,
      "CategoryID": 27,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Porch Covers | Outdoor living Area",
      "Description": "No Concrete Pads or Decks Included in Base Price of Home",
      "Type": "S",
      "AID": 24520,
      "CategoryID": 27,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Porch Cover ",
      "Description": "14' x 10' Covered Patio",
      "Type": "O",
      "AID": 24521,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3500,
          "AID": 24521,
          "APID": 47260,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Porch Cover ",
      "Description": "22' x 14' Covered Patio",
      "Type": "O",
      "AID": 24522,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 6200,
          "AID": 24522,
          "APID": 47261,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Porch Cover ",
      "Description": "Wrap Around Porch (max dept 6') | Price Per Ft",
      "Type": "O",
      "AID": 24523,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24523,
          "APID": 47262,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "Single 10' Gable",
      "Type": "O",
      "AID": 24524,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1600,
          "AID": 24524,
          "APID": 47351,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "Single 16' Gable",
      "Type": "O",
      "AID": 24525,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1900,
          "AID": 24525,
          "APID": 47352,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "22' Double Gable",
      "Type": "O",
      "AID": 24526,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2800,
          "AID": 24526,
          "APID": 47353,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "8' Gable Porch Cover",
      "Type": "O",
      "AID": 24527,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24527,
          "APID": 47354,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "12' Gable Porch Cover",
      "Type": "O",
      "AID": 24528,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 5100,
          "AID": 24528,
          "APID": 47355,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "Porch Cover",
      "Type": "O",
      "AID": 24529,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 55,
          "AID": 24529,
          "APID": 47356,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "Porch Cover with Pine Covered Soffit",
      "Type": "O",
      "AID": 24530,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 80,
          "AID": 24530,
          "APID": 47357,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "Timber Framed Accent at Gable Porch",
      "Type": "O",
      "AID": 24531,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 110,
          "AID": 24531,
          "APID": 47358,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "16\"x30\" Stone for Porch Posts",
      "Type": "O",
      "AID": 24532,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 575,
          "AID": 24532,
          "APID": 47359,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "20\"x30\" Stone for Porch Posts",
      "Type": "O",
      "AID": 24533,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 630,
          "AID": 24533,
          "APID": 47360,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "24\"x30\" Stone for Porch Posts",
      "Type": "O",
      "AID": 24534,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 700,
          "AID": 24534,
          "APID": 47361,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "22' Gable with 8' Porch Cover",
      "Type": "O",
      "AID": 24535,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3200,
          "AID": 24535,
          "APID": 47362,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "FiberOn Deck with Redwood Handrails",
      "Type": "O",
      "AID": 24536,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 60,
          "AID": 24536,
          "APID": 47363,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "FiberOn Deck without Handrails | Maximum 30\" Off Ground",
      "Type": "O",
      "AID": 24537,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 50,
          "AID": 24537,
          "APID": 47364,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Porch Covers | Outdoor Living Area",
      "Description": "FiberOn Deck with Redwood Handrails | 2nd Story with Glulam Beams and Posts",
      "Type": "O",
      "AID": 24538,
      "CategoryID": 27,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 85,
          "AID": 24538,
          "APID": 47365,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Windows | Skylights",
      "Description": "French Door in Place of Sliding Glass Door ",
      "Type": "O",
      "AID": 24539,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2000,
          "AID": 24539,
          "APID": 47327,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "8 Sliding Glass Door in Place of 6' Sliding Glass Door ",
      "Type": "O",
      "AID": 24540,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 785,
          "AID": 24540,
          "APID": 47328,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "French Door Stand Alone w/ Light ",
      "Type": "O",
      "AID": 24541,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2600,
          "AID": 24541,
          "APID": 47329,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "French Door in Place of Window ",
      "Type": "O",
      "AID": 24542,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2300,
          "AID": 24542,
          "APID": 47330,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "8' Slider with Exterior Light",
      "Type": "O",
      "AID": 24543,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1750,
          "AID": 24543,
          "APID": 47331,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "8' Slider in Place of Window ",
      "Type": "O",
      "AID": 24544,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1200,
          "AID": 24544,
          "APID": 47332,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "Gridded Windows | Priced Per Each",
      "Type": "O",
      "AID": 24545,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 85,
          "AID": 24545,
          "APID": 47333,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "6' Sliding Glass Door w/ Light in Place of 6x4 Window",
      "Type": "O",
      "AID": 24546,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 850,
          "AID": 24546,
          "APID": 47334,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "Grid Sliding Glass Doors | Priced Per Each ",
      "Type": "O",
      "AID": 24547,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 85,
          "AID": 24547,
          "APID": 47335,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "10' Solar Tube | Priced Per",
      "Type": "O",
      "AID": 24548,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 850,
          "AID": 24548,
          "APID": 47297,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "Black Vinyl Exterior | White Interior | Triple Glazed | .24 U-Value | Low E | Argon Filled | Energy Spacers| Includes Screens | Installed Using Advanced Butyl Flashing Systems and Drain Pan when applicable | Over 2000 SqFt Home",
      "Type": "O",
      "AID": 24550,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 14,
          "Price": 5500,
          "AID": 24550,
          "APID": 47511,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 15,
          "Price": 5500,
          "AID": 24550,
          "APID": 47512,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 16,
          "Price": 5500,
          "AID": 24550,
          "APID": 47513,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 17,
          "Price": 5500,
          "AID": 24550,
          "APID": 47514,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 18,
          "Price": 5500,
          "AID": 24550,
          "APID": 47515,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 19,
          "Price": 5500,
          "AID": 24550,
          "APID": 47516,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 26,
          "Price": 5500,
          "AID": 24550,
          "APID": 47517,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 28,
          "Price": 5500,
          "AID": 24550,
          "APID": 47518,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 29,
          "Price": 5500,
          "AID": 24550,
          "APID": 47519,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 30,
          "Price": 5500,
          "AID": 24550,
          "APID": 47520,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 32,
          "Price": 5500,
          "AID": 24550,
          "APID": 47521,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 33,
          "Price": 5500,
          "AID": 24550,
          "APID": 47522,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 34,
          "Price": 5500,
          "AID": 24550,
          "APID": 47523,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 35,
          "Price": 5500,
          "AID": 24550,
          "APID": 47524,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 41,
          "Price": 5500,
          "AID": 24550,
          "APID": 47525,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 45,
          "Price": 5500,
          "AID": 24550,
          "APID": 47526,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 46,
          "Price": 5500,
          "AID": 24550,
          "APID": 47527,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 47,
          "Price": 5500,
          "AID": 24550,
          "APID": 47528,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 48,
          "Price": 5500,
          "AID": 24550,
          "APID": 47529,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 51,
          "Price": 5500,
          "AID": 24550,
          "APID": 47530,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 52,
          "Price": 5500,
          "AID": 24550,
          "APID": 47531,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 53,
          "Price": 5500,
          "AID": 24550,
          "APID": 47532,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 55,
          "Price": 5500,
          "AID": 24550,
          "APID": 47533,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 56,
          "Price": 5500,
          "AID": 24550,
          "APID": 47534,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 58,
          "Price": 5500,
          "AID": 24550,
          "APID": 47535,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 59,
          "Price": 5500,
          "AID": 24550,
          "APID": 47536,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 61,
          "Price": 5500,
          "AID": 24550,
          "APID": 47537,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 64,
          "Price": 5500,
          "AID": 24550,
          "APID": 47538,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 66,
          "Price": 5500,
          "AID": 24550,
          "APID": 47539,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 71,
          "Price": 5500,
          "AID": 24550,
          "APID": 47540,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 72,
          "Price": 5500,
          "AID": 24550,
          "APID": 47541,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 80,
          "Price": 5500,
          "AID": 24550,
          "APID": 47542,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 81,
          "Price": 5500,
          "AID": 24550,
          "APID": 47543,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 82,
          "Price": 5500,
          "AID": 24550,
          "APID": 47544,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 83,
          "Price": 5500,
          "AID": 24550,
          "APID": 47545,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 88,
          "Price": 5500,
          "AID": 24550,
          "APID": 47546,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 90,
          "Price": 5500,
          "AID": 24550,
          "APID": 47547,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 96,
          "Price": 5500,
          "AID": 24550,
          "APID": 47548,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 100,
          "Price": 5500,
          "AID": 24550,
          "APID": 47549,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 101,
          "Price": 5500,
          "AID": 24550,
          "APID": 47550,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 130,
          "Price": 5500,
          "AID": 24550,
          "APID": 47551,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 133,
          "Price": 5500,
          "AID": 24550,
          "APID": 47552,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 135,
          "Price": 5500,
          "AID": 24550,
          "APID": 47553,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 138,
          "Price": 5500,
          "AID": 24550,
          "APID": 47554,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 140,
          "Price": 5500,
          "AID": 24550,
          "APID": 47555,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 155,
          "Price": 5500,
          "AID": 24550,
          "APID": 47556,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 157,
          "Price": 5500,
          "AID": 24550,
          "APID": 47557,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 159,
          "Price": 5500,
          "AID": 24550,
          "APID": 47558,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 165,
          "Price": 5500,
          "AID": 24550,
          "APID": 47559,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 166,
          "Price": 5500,
          "AID": 24550,
          "APID": 47560,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 167,
          "Price": 5500,
          "AID": 24550,
          "APID": 47561,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 168,
          "Price": 5500,
          "AID": 24550,
          "APID": 47562,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 169,
          "Price": 5500,
          "AID": 24550,
          "APID": 47563,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 170,
          "Price": 5500,
          "AID": 24550,
          "APID": 47564,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 171,
          "Price": 5500,
          "AID": 24550,
          "APID": 47565,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 172,
          "Price": 5500,
          "AID": 24550,
          "APID": 47566,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 173,
          "Price": 5500,
          "AID": 24550,
          "APID": 47567,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 179,
          "Price": 5500,
          "AID": 24550,
          "APID": 47568,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 183,
          "Price": 5500,
          "AID": 24550,
          "APID": 47569,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 184,
          "Price": 5500,
          "AID": 24550,
          "APID": 47570,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 198,
          "Price": 5500,
          "AID": 24550,
          "APID": 47571,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 199,
          "Price": 5500,
          "AID": 24550,
          "APID": 47572,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 200,
          "Price": 5500,
          "AID": 24550,
          "APID": 47573,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 208,
          "Price": 5500,
          "AID": 24550,
          "APID": 47574,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 213,
          "Price": 5500,
          "AID": 24550,
          "APID": 47575,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 234,
          "Price": 5500,
          "AID": 24550,
          "APID": 47576,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 235,
          "Price": 5500,
          "AID": 24550,
          "APID": 47577,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 237,
          "Price": 5500,
          "AID": 24550,
          "APID": 47578,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 240,
          "Price": 5500,
          "AID": 24550,
          "APID": 47579,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 241,
          "Price": 5500,
          "AID": 24550,
          "APID": 47580,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 243,
          "Price": 5500,
          "AID": 24550,
          "APID": 47581,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 246,
          "Price": 5500,
          "AID": 24550,
          "APID": 47582,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 249,
          "Price": 5500,
          "AID": 24550,
          "APID": 47583,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 250,
          "Price": 5500,
          "AID": 24550,
          "APID": 47584,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 252,
          "Price": 5500,
          "AID": 24550,
          "APID": 47585,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 255,
          "Price": 5500,
          "AID": 24550,
          "APID": 47586,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 257,
          "Price": 5500,
          "AID": 24550,
          "APID": 47587,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 259,
          "Price": 5500,
          "AID": 24550,
          "APID": 47588,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 260,
          "Price": 5500,
          "AID": 24550,
          "APID": 47589,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 261,
          "Price": 5500,
          "AID": 24550,
          "APID": 47590,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 263,
          "Price": 5500,
          "AID": 24550,
          "APID": 47591,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 265,
          "Price": 5500,
          "AID": 24550,
          "APID": 47592,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 278,
          "Price": 5500,
          "AID": 24550,
          "APID": 47593,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 280,
          "Price": 5500,
          "AID": 24550,
          "APID": 47594,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 281,
          "Price": 5500,
          "AID": 24550,
          "APID": 47595,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 282,
          "Price": 5500,
          "AID": 24550,
          "APID": 47596,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 283,
          "Price": 5500,
          "AID": 24550,
          "APID": 47597,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 284,
          "Price": 5500,
          "AID": 24550,
          "APID": 47598,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        },
        {
          "PlanID": 285,
          "Price": 5500,
          "AID": 24550,
          "APID": 47599,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Windows | Skylights",
      "Description": "Add 12' Double Sliding Glass Door",
      "Type": "O",
      "AID": 24551,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3500,
          "AID": 24551,
          "APID": 47348,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Windows |Skylights",
      "Description": "2' x 2' Skylight ",
      "Type": "O",
      "AID": 24552,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 500,
          "AID": 24552,
          "APID": 47253,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "6' x 2' Skylight",
      "Type": "O",
      "AID": 24553,
      "CategoryID": 28,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 950,
          "AID": 24553,
          "APID": 47254,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Windows | Skylights",
      "Description": "White Vinyl | Triple Glazed | .27 U-Value | Low E | Argon Filled | Energy Spacers| Includes Screens | Bathroom Include Privacy glass | Installed Using Advanced Butyl Flashing Systems and Drain Pan when applicable",
      "Type": "S",
      "AID": 26600,
      "CategoryID": 28,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Exterior Doors",
      "Description": "Therma-Tru Patio Door |1/2-Lite | Paint Grade S206 | When Applicable",
      "Type": "S",
      "AID": 24557,
      "CategoryID": 29,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Exterior Doors",
      "Description": "Therma-Tru 20 Minute Fire Rated Door | When Applicable",
      "Type": "S",
      "AID": 24558,
      "CategoryID": 29,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Exterior Doors",
      "Description": "Replace 1/2-Lite with Therma-Tru Full Lite Door | Paint Grade S118",
      "Type": "O",
      "AID": 24559,
      "CategoryID": 29,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1000,
          "AID": 24559,
          "APID": 47601,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T11:57:37.253Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Exterior Doors",
      "Description": "Install Man-Door In Garage",
      "Type": "O",
      "AID": 24560,
      "CategoryID": 29,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1500,
          "AID": 24560,
          "APID": 47401,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:03:26.406Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Exterior Door",
      "Description": "Therma-Tru Front Door | Paint Grade Model S236",
      "Type": "S",
      "AID": 26499,
      "CategoryID": 29,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Siding",
      "Description": "Board & Batten Style Siding | Front Elevation Only",
      "Type": "O",
      "AID": 24561,
      "CategoryID": 30,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 5100,
          "AID": 24561,
          "APID": 47347,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Siding",
      "Description": "Add Metal Wainscot on Bottom 36\" of Home Exterior",
      "Type": "O",
      "AID": 24562,
      "CategoryID": 30,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 5500,
          "AID": 24562,
          "APID": 47600,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Siding",
      "Description": "Exterior Stone Accent",
      "Type": "O",
      "AID": 24563,
      "CategoryID": 30,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 35,
          "AID": 24563,
          "APID": 47349,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Siding",
      "Description": "Gable Shakes ",
      "Type": "O",
      "AID": 24564,
      "CategoryID": 30,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 5800,
          "AID": 24564,
          "APID": 47343,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Siding",
      "Description": "5\" Dutch Lap Vinyl Siding - Entire Home with Shakes ",
      "Type": "O",
      "AID": 24565,
      "CategoryID": 30,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1250,
          "AID": 24565,
          "APID": 47344,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Siding",
      "Description": "Superior Moisture Protection: Drainage and Air Barrier House Wrap | Butyl Mastic Applied at All Corners |  3\" High Backed Flashing w/110 Bend Metal Drip Edge",
      "Type": "S",
      "AID": 24568,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Siding",
      "Description": "Cement Lap Siding Body | Cement Lap Siding Gables | 25 Year Manufacturers Warranty",
      "Type": "S",
      "AID": 24569,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Siding",
      "Description": "6\" Accented Gable Belly Band | 4\" Gable Frieze Board | 6\" Barge & Fascia Board (or Greater Depending on Roof Pitch) | 4\" Corners |4\" Window Trim w/ 4\" Header Trim",
      "Type": "S",
      "AID": 24570,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Siding",
      "Description": "Porch Posts and Headers Wrapped w/ LP Trim (If Applicable Per Plan)",
      "Type": "S",
      "AID": 24571,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Siding",
      "Description": "Enclosed Soffits | Vented at Eaves",
      "Type": "S",
      "AID": 24572,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Siding",
      "Description": "No Stone Accents Included",
      "Type": "S",
      "AID": 24573,
      "CategoryID": 30,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "PEX Advanced Piping System | Polymer Fittings | All Other Plumbing Per Code",
      "Type": "S",
      "AID": 24584,
      "CategoryID": 31,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "50 Gallon | High Efficient | Hot Water Heater | Located in Garage if applicable",
      "Type": "S",
      "AID": 24585,
      "CategoryID": 31,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "(2) Exterior Frost Free Hose Bibs | (1) Front | (1) Rear if applicable",
      "Type": "S",
      "AID": 24586,
      "CategoryID": 31,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Water/Ice Rough-in Supply For Refrigerator",
      "Type": "S",
      "AID": 24587,
      "CategoryID": 31,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Main Bath Units: As Per Plan | Fiberglass Tubs | Tub/Shower Combos | Glass Door Not Included",
      "Type": "S",
      "AID": 24588,
      "CategoryID": 31,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Additional Plumbing Rough In | Fixtures Not Included",
      "Type": "O",
      "AID": 24593,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1100,
          "AID": 24593,
          "APID": 47375,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Unfinished Basement Plumbing Rough In | Fixtures, Pump, & Sewer Work Not Included",
      "Type": "O",
      "AID": 24594,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1250,
          "AID": 24594,
          "APID": 47376,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Upgrade to Tall Oval Toilet | Priced per Each",
      "Type": "O",
      "AID": 24595,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 225,
          "AID": 24595,
          "APID": 47377,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Add Free Standing Utility Sink",
      "Type": "O",
      "AID": 24596,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1250,
          "AID": 24596,
          "APID": 47378,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Add In Cabinet Utility Sink | To Include Granite Countertop",
      "Type": "O",
      "AID": 24597,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1650,
          "AID": 24597,
          "APID": 47379,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Add RV Hook Up Disposal",
      "Type": "O",
      "AID": 24598,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1100,
          "AID": 24598,
          "APID": 47395,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Additional Bathroom Sink",
      "Type": "O",
      "AID": 24599,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 850,
          "AID": 24599,
          "APID": 47388,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Additional Bathroom Toilet",
      "Type": "O",
      "AID": 24600,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 850,
          "AID": 24600,
          "APID": 47389,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Additional Bathroom Shower",
      "Type": "O",
      "AID": 24601,
      "CategoryID": 31,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2200,
          "AID": 24601,
          "APID": 47390,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Plumbing",
      "Description": "Master Bath Units: As Per Plan | Fiberglass Tub | Fiberglass shower | Tub/Shower Combos | Glass Door Not Included.",
      "Type": "S",
      "AID": 26601,
      "CategoryID": 31,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Add Cadet Wall Heater | Priced per Each",
      "Type": "O",
      "AID": 24602,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 525,
          "AID": 24602,
          "APID": 47383,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Additional Phone or TV Jack | Priced per Each Location",
      "Type": "O",
      "AID": 24603,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 65,
          "AID": 24603,
          "APID": 47384,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Additional 110v Outlet in Crawl Space",
      "Type": "O",
      "AID": 24604,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 200,
          "AID": 24604,
          "APID": 47385,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Add 400 Amp Electrical Panel | For Future Outbuildings",
      "Type": "O",
      "AID": 24605,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1800,
          "AID": 24605,
          "APID": 47386,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Add 30amp Generator Ready Electrical Panel",
      "Type": "O",
      "AID": 24606,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1250,
          "AID": 24606,
          "APID": 47387,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Additional Recessed Can Light | Priced per Each",
      "Type": "O",
      "AID": 24607,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 105,
          "AID": 24607,
          "APID": 47380,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Under Cabinet Lighting | Four Zones",
      "Type": "O",
      "AID": 24608,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 975,
          "AID": 24608,
          "APID": 47381,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Paddle Fan Rough-In | Switch & Out | Homeowner to Supply Fan | 2 Included Standard ",
      "Type": "S",
      "AID": 24609,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 0,
          "AID": 24609,
          "APID": 47370,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Overhead Power Connection",
      "Type": "O",
      "AID": 24610,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3000,
          "AID": 24610,
          "APID": 47350,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Rough Electrical",
      "Description": "Electrical Per Code | Outlets: Per Local Code",
      "Type": "S",
      "AID": 24611,
      "CategoryID": 32,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Electrical",
      "Description": "200 Amp Circuit Panel",
      "Type": "S",
      "AID": 24612,
      "CategoryID": 32,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Electrical",
      "Description": "(2) GFCI Weather Proof Exterior Outlets |  (1) Front | (1) Rear if applicable.",
      "Type": "S",
      "AID": 24613,
      "CategoryID": 32,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Electrical",
      "Description": "Pre-Wire TV/Phone Drops | (4) Total | Includes (2) USB Outlets | Owner to Determine Location and Place Per Plan",
      "Type": "S",
      "AID": 24614,
      "CategoryID": 32,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Electrical",
      "Description": "If Separate Unattached Garage Sold, Includes: 60 Amp Circuit Panel | Outlets Per Code",
      "Type": "S",
      "AID": 24615,
      "CategoryID": 32,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Rough Electrical ",
      "Description": "Additional Paddle Fan Rough-In | Switch & Out | Homeowner to Supply Fan",
      "Type": "O",
      "AID": 24618,
      "CategoryID": 32,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 550,
          "AID": 24618,
          "APID": 47255,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Finish Electric",
      "Description": "White Light Switches | White Outlet Covers",
      "Type": "S",
      "AID": 24619,
      "CategoryID": 33,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Heating | Cooling",
      "Description": "Performance Package Electric Air Handler w/ Energy Star Qualified Heat Pump | Located in Garage when in applicable",
      "Type": "S",
      "AID": 24621,
      "CategoryID": 34,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Ventilation",
      "Description": "Baths: 30-100 CFM | Switched | High Efficient Exhaust Fan",
      "Type": "S",
      "AID": 24624,
      "CategoryID": 35,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Ventilation",
      "Description": "Powder: 80 CFM | High Efficient | Exhaust Fan/Light Combo",
      "Type": "S",
      "AID": 24625,
      "CategoryID": 35,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Ventilation",
      "Description": "Utility: 80 CFM | Switched | High Efficient Exhaust Fan",
      "Type": "S",
      "AID": 24626,
      "CategoryID": 35,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Gutters",
      "Description": "White Seamless Gutters ",
      "Type": "O",
      "AID": 24631,
      "CategoryID": 36,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 800,
          "AID": 24631,
          "APID": 47288,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Insulation",
      "Description": "Exterior Walls: R-23 Blown In Wall Insulation",
      "Type": "S",
      "AID": 24633,
      "CategoryID": 37,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Insulation",
      "Description": "Ceiling: R-49 Blown-In | R-38 High Density Starter Batts in Eves ",
      "Type": "S",
      "AID": 24634,
      "CategoryID": 37,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Insulation",
      "Description": "Floor: R-30 Batts",
      "Type": "S",
      "AID": 24635,
      "CategoryID": 37,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Insulation",
      "Description": "Miscellaneous: R-7 Rigid Insulated Engineered Headers |Attic Rulers | Crack Seal | Baffles | Foam Seal | Ridged In Vaulted Areas | High Performance 6-Sided Insulation Installation Methods Used in All Locations",
      "Type": "S",
      "AID": 24636,
      "CategoryID": 37,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Insulation ",
      "Description": "Interior Wall Insulation ",
      "Type": "O",
      "AID": 24637,
      "CategoryID": 37,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 600,
          "AID": 24637,
          "APID": 47336,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Drywall",
      "Description": "Fire Rated Sheetrock for Interior of Home ",
      "Type": "O",
      "AID": 24638,
      "CategoryID": 38,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 900,
          "AID": 24638,
          "APID": 47337,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Drywall | Skylights",
      "Description": "Rounded Corners for 2' x 2' Skylights | Priced Per Each ",
      "Type": "O",
      "AID": 24639,
      "CategoryID": 38,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 150,
          "AID": 24639,
          "APID": 47338,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Drywall | Skylights",
      "Description": "Rounded Corners for 6' x 2' Skylights | Priced Per Each ",
      "Type": "O",
      "AID": 24640,
      "CategoryID": 38,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 200,
          "AID": 24640,
          "APID": 47339,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Drywall | Windows",
      "Description": "Rounded Corners for All Windows and Sliding Glass Doors ",
      "Type": "O",
      "AID": 24641,
      "CategoryID": 38,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 800,
          "AID": 24641,
          "APID": 47340,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Drywall",
      "Description": "Walls: Advanced Drywall Application | 1/2\" Standard Gypsum Board | PVA Primer (Vapor Barrier) on Exterior Walls | Light to Medium Texture",
      "Type": "S",
      "AID": 24642,
      "CategoryID": 38,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Drywall",
      "Description": "Ceiling: Advanced Drywall Application | 1/2\" Standard Gypsum Board or 5/8\" when applicable | PVA Primed (Vapor Barrier) | Double Stomp Texture",
      "Type": "S",
      "AID": 24643,
      "CategoryID": 38,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Drywall",
      "Description": "Attached Garages: 1/2\" Fire Rated Board Only on Walls That Require Fire Blocking U.N.O. | Fire Taped Only | No Finished Mud or Texture",
      "Type": "S",
      "AID": 24644,
      "CategoryID": 38,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Painting",
      "Description": "Exterior Paint: (3) Paint Scheme | Main Home Color, Gables & Trim",
      "Type": "S",
      "AID": 24648,
      "CategoryID": 39,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Painting",
      "Description": "Interior Paint: (1) Interior Color with White Trim",
      "Type": "S",
      "AID": 24649,
      "CategoryID": 39,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Cabinets",
      "Description": "Features: Huntwood Cabinets with Crown Molding | Standard Knob and Pull Hardware | Solid Wood Dove Tailed Drawers | Soft Close Doors And Drawers | 36\" Uppers | 36\" Vanity height",
      "Type": "S",
      "AID": 24650,
      "CategoryID": 40,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Cabinets",
      "Description": "Species: Beech Species | Premium Wood Species Available for Additional Fees",
      "Type": "S",
      "AID": 24651,
      "CategoryID": 40,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Cabinets",
      "Description": "Door Styles: Choice of Multiple Door Styles | Premium Door Styles Available for Additional Fees",
      "Type": "S",
      "AID": 24652,
      "CategoryID": 40,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Cabinets",
      "Description": "Finish: Choice of Multiple Stain Color Selections (Multiple Paint Colors Available for Additional Fees)",
      "Type": "S",
      "AID": 24653,
      "CategoryID": 40,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Cabinets",
      "Description": "Add Double Oven Kitchen Cabinet",
      "Type": "O",
      "AID": 24657,
      "CategoryID": 40,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2000,
          "AID": 24657,
          "APID": 47382,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Cabinets",
      "Description": "Additional Bathroom Cabinet",
      "Type": "O",
      "AID": 24658,
      "CategoryID": 40,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1800,
          "AID": 24658,
          "APID": 47391,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Cabinets",
      "Description": "Add Cabinets Above Washer/Dryer in Laundry Room | Priced per Box",
      "Type": "O",
      "AID": 24659,
      "CategoryID": 40,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 700,
          "AID": 24659,
          "APID": 47392,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Countertops | Sinks",
      "Description": "Composite Kitchen Sink",
      "Type": "O",
      "AID": 24660,
      "CategoryID": 41,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 650,
          "AID": 24660,
          "APID": 47393,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Countertops ",
      "Description": "3cm Granite or Quartz On All Counter-Top Surfaces | Multiple Color Options ",
      "Type": "S",
      "AID": 24662,
      "CategoryID": 41,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Countertops | Backsplash",
      "Description": "Lexar Standard full height tile in Kitchen Backsplash | 6\" Lexar Standard Tile in Bathroom Backsplash",
      "Type": "S",
      "AID": 25726,
      "CategoryID": 41,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Kitchen Sink: Under-mount | Deep Stainless | Double or Single Basin options available",
      "Type": "S",
      "AID": 24663,
      "CategoryID": 42,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Bathroom Sinks: Under-mount | White | Oval",
      "Type": "S",
      "AID": 24664,
      "CategoryID": 42,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Kitchen Fixtures: Manufacturer - Pfister | Gooseneck | Pull Spray | Multiple Standard Colors Included",
      "Type": "S",
      "AID": 24665,
      "CategoryID": 42,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Bath Fixtures: Manufacturer - Pfister | 4\" Spread | Multiple Standard Colors Included",
      "Type": "S",
      "AID": 24666,
      "CategoryID": 42,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Finish Plumbing ",
      "Description": "5' Fiberglass Shower in Place of 5' Tub/Shower Combo",
      "Type": "O",
      "AID": 24668,
      "CategoryID": 42,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 850,
          "AID": 24668,
          "APID": 47256,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Jetted Tub in Place of 5' Soaker",
      "Type": "O",
      "AID": 24669,
      "CategoryID": 42,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3000,
          "AID": 24669,
          "APID": 47257,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Electric Hot Water Tank | 80 Gallon ",
      "Type": "O",
      "AID": 24670,
      "CategoryID": 42,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2100,
          "AID": 24670,
          "APID": 47258,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Finish Plumbing ",
      "Description": "Gas Hot Water Tank | 50 Gallon ",
      "Type": "O",
      "AID": 24671,
      "CategoryID": 42,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1100,
          "AID": 24671,
          "APID": 47259,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Finish Plumbing",
      "Description": "Tankless Gas Water Heater | 200,000 BTU | Does Not Include Rough In",
      "Type": "O",
      "AID": 24672,
      "CategoryID": 42,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 3800,
          "AID": 24672,
          "APID": 47394,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Built in Shelves | Maximum of 4",
      "Type": "O",
      "AID": 24673,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1200,
          "AID": 24673,
          "APID": 47396,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Built in Bench with Coat Hook and Cubby | per ft | min 3' length",
      "Type": "O",
      "AID": 24674,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 500,
          "AID": 24674,
          "APID": 47397,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:15:23.160Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Painted MDF Crown Molding at Ceiling | Priced per Lineal Foot",
      "Type": "O",
      "AID": 24675,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 8.25,
          "AID": 24675,
          "APID": 47398,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Stained Wood Crown Molding at Ceiling | Priced per Lineal Foot",
      "Type": "O",
      "AID": 24676,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 35,
          "AID": 24676,
          "APID": 47399,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Interior French Door with Glass",
      "Type": "O",
      "AID": 24677,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2000,
          "AID": 24677,
          "APID": 47400,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:30:33.270Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Wood Interior Doors and Trim | Per Selection Sheet",
      "Type": "O",
      "AID": 24678,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 14500,
          "AID": 24678,
          "APID": 47402,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Sliding Alder Barn Door",
      "Type": "O",
      "AID": 24679,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 2000,
          "AID": 24679,
          "APID": 47403,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:16:03.930Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Handicap Accessible Doorways| Priced per Each",
      "Type": "O",
      "AID": 24680,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 225,
          "AID": 24680,
          "APID": 47404,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add MDF Shiplap Wall Accent | Priced per Square Foot",
      "Type": "O",
      "AID": 24681,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 6.5,
          "AID": 24681,
          "APID": 47405,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Wood Shiplap Wall Accent | Priced per Square Foot",
      "Type": "O",
      "AID": 24682,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 10,
          "AID": 24682,
          "APID": 47406,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:16:53.556Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Add Interior Stone Accent | Priced per Square Foot",
      "Type": "O",
      "AID": 24683,
      "CategoryID": 43,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 28,
          "AID": 24683,
          "APID": 47407,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Primed MDF Hollow Core Interior Doors | Multiple Styles to Select From | Per Selection Sheet",
      "Type": "S",
      "AID": 24697,
      "CategoryID": 43,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Craftsman Style | Primed MDF | Trim Base 1/2\"x4\" | Door Legs 1\"x4\" | Door Header 5/4\"x6\"",
      "Type": "S",
      "AID": 24698,
      "CategoryID": 43,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Interior Trim | Millwork",
      "Description": "Sill and Apron Windows in Craftsman Style",
      "Type": "S",
      "AID": 26476,
      "CategoryID": 43,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Door Hardware",
      "Description": "Style: Kwikset Interior/Exterior Lever Door Handles | Finish: Brushed Nickel | Hinges, Bi-Pass Cups and Stops",
      "Type": "S",
      "AID": 24700,
      "CategoryID": 44,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Door Hardware",
      "Description": "Deadbolts | Priced Per Door ",
      "Type": "O",
      "AID": 24702,
      "CategoryID": 44,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 150,
          "AID": 24702,
          "APID": 47345,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Shelving | Mirrors",
      "Description": "White Vinyl Custom Shelving | Shelf and Clothes Rod in Entry and Bedroom Closets | Multiple Shelves in Pantries and Storage Closets | Frame-less Mirrors Sized According to Vanity",
      "Type": "S",
      "AID": 24704,
      "CategoryID": 45,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Flooring",
      "Description": "Signature Homes | Group A LVP Included in Wet Areas and Main Living area| Group B Carpet included in Bedrooms, Offices, Dens, Bonus Rooms, Stairs and any additional living areas|",
      "Type": "S",
      "AID": 26597,
      "CategoryID": 46,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Lighting",
      "Description": "Dining: Chandelier in Multiple Finishes",
      "Type": "S",
      "AID": 24714,
      "CategoryID": 47,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Lighting",
      "Description": "Bathroom: Vanity Bar Lights Above Sinks | Multiple Finishes | Quanity and Size per Plan",
      "Type": "S",
      "AID": 24715,
      "CategoryID": 47,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Lighting",
      "Description": "Pendants - Pendants Over Island and Kitchen Sink (Quantity as Noted Per Electrical Plan)",
      "Type": "S",
      "AID": 24718,
      "CategoryID": 47,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Lighting",
      "Description": "Exterior Lights: (1) Per Entrance | (1) On Each Side of Garage Doors",
      "Type": "S",
      "AID": 24719,
      "CategoryID": 47,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Lighting",
      "Description": "Flush Mount LED Lights | Plan includes 10 flush mount lights | Location determined by homeowner",
      "Type": "S",
      "AID": 26598,
      "CategoryID": 47,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Office | Clerical | Cert. Testing",
      "Description": "Building Permit Application Documents For Lexar Structures Provided",
      "Type": "S",
      "AID": 24721,
      "CategoryID": 49,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Fireplace",
      "Description": "No Fireplace was Ordered | Not Applicable to Contract",
      "Type": "S",
      "AID": 24726,
      "CategoryID": 51,
      "AssemblyPriceTable": []
    },
    {
      "Name": "Fireplace",
      "Description": "Gas Fireplace | Lexar Standard Selection | Flush Wall | Raised 12\"| Includes stone finish to mantel | Includes 60\" stained mantel(Varies per code)",
      "Type": "O",
      "AID": 24727,
      "CategoryID": 51,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 7000,
          "AID": 24727,
          "APID": 47366,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Fireplace",
      "Description": "Pellet Stove | Lexar Standard Selection | Flush Wall | Raised 12\"| Includes stone finish to mantel | Includes 60\" stained mantel(Varies per code)",
      "Type": "O",
      "AID": 24728,
      "CategoryID": 51,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 9000,
          "AID": 24728,
          "APID": 47367,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:48:31.723Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Fireplace",
      "Description": "Wood Fireplace Inset | Lexar Standard Selection | Flush Wall | Raised 12\"| Includes stone finish to mantel | Includes 60\" mantel(Varies per code)",
      "Type": "O",
      "AID": 24729,
      "CategoryID": 51,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 12000,
          "AID": 24729,
          "APID": 47368,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:49:16.943Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Fireplace",
      "Description": "Wood Stove | Lexar Standard Selection | Exposed Pipe to Ceiling",
      "Type": "O",
      "AID": 24730,
      "CategoryID": 51,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 8500,
          "AID": 24730,
          "APID": 47369,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2024-01-04T12:50:03.293Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Detached Garage ",
      "Description": "Base Price for 720 Garage ",
      "Type": "O",
      "AID": 24733,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 20900,
          "AID": 24733,
          "APID": 47298,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Base Price for 952 Garage ",
      "Type": "O",
      "AID": 24734,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 25900,
          "AID": 24734,
          "APID": 47299,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Base Price for 1216 Garage ",
      "Type": "O",
      "AID": 24735,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 31900,
          "AID": 24735,
          "APID": 47300,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Additional Foundation | Priced Per ",
      "Type": "O",
      "AID": 24736,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24736,
          "APID": 47301,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "8' Garage Door in Place of 7' Standard Door ",
      "Type": "O",
      "AID": 24737,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 500,
          "AID": 24737,
          "APID": 47302,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Move 16' x 8' Garage Door ",
      "Type": "O",
      "AID": 24738,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 600,
          "AID": 24738,
          "APID": 47303,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Insulated 16' x 8' Garage Door ",
      "Type": "O",
      "AID": 24739,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 500,
          "AID": 24739,
          "APID": 47304,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Insulated 10' x 8' Garage Door ",
      "Type": "O",
      "AID": 24740,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 350,
          "AID": 24740,
          "APID": 47305,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Garage Door Opener | Includes 2 Remotes ",
      "Type": "O",
      "AID": 24741,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 450,
          "AID": 24741,
          "APID": 47306,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "4' x 4' Garage Window ",
      "Type": "O",
      "AID": 24742,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 550,
          "AID": 24742,
          "APID": 47307,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Sheetrock & Flush Tape Interior of Detached Garage ",
      "Type": "O",
      "AID": 24743,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24743,
          "APID": 47308,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Insulate Walls & Ceiling of Detached Garage ",
      "Type": "O",
      "AID": 24744,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24744,
          "APID": 47309,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Mandoor Installed in Detached garage w/ Ext Light ",
      "Type": "O",
      "AID": 24745,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 790,
          "AID": 24745,
          "APID": 47310,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Ridge Vent Installed ",
      "Type": "O",
      "AID": 24746,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 600,
          "AID": 24746,
          "APID": 47311,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Power Attic Vent (Moisture Control)",
      "Type": "O",
      "AID": 24747,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 550,
          "AID": 24747,
          "APID": 47312,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "6/12 Pitched Roof ",
      "Type": "O",
      "AID": 24748,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24748,
          "APID": 47313,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Pro 50-year Roof",
      "Type": "O",
      "AID": 24749,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24749,
          "APID": 47314,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Cement- Lap Siding | Entire Garage ",
      "Type": "O",
      "AID": 24750,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24750,
          "APID": 47315,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Gable Shakes ",
      "Type": "O",
      "AID": 24751,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24751,
          "APID": 47316,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "5\" Dutch Lap Vinyl Siding | Entire Garage w/ Shakes ",
      "Type": "O",
      "AID": 24752,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24752,
          "APID": 47317,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Gutters ",
      "Type": "O",
      "AID": 24753,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 1,
          "AID": 24753,
          "APID": 47318,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "2' x 2' Skylight",
      "Type": "O",
      "AID": 24754,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 350,
          "AID": 24754,
          "APID": 47319,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "6' x 2' Skylight",
      "Type": "O",
      "AID": 24755,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 600,
          "AID": 24755,
          "APID": 47320,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Additional Outlets on a Single LIne",
      "Type": "O",
      "AID": 24756,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 75,
          "AID": 24756,
          "APID": 47321,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "60 AMP Panel ",
      "Type": "O",
      "AID": 24757,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 200,
          "AID": 24757,
          "APID": 47322,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "30 AMP Generator Ready Electrical Panel ",
      "Type": "O",
      "AID": 24758,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 750,
          "AID": 24758,
          "APID": 47323,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Phone Pre-Wire ",
      "Type": "O",
      "AID": 24759,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 50,
          "AID": 24759,
          "APID": 47324,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "TV (Cable) Pre-Wire ",
      "Type": "O",
      "AID": 24760,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 50,
          "AID": 24760,
          "APID": 47325,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage ",
      "Description": "Grid Windows | Priced Per Each ",
      "Type": "O",
      "AID": 24761,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 85,
          "AID": 24761,
          "APID": 47326,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ]
    },
    {
      "Name": "Detached Garage",
      "Description": "Additional Garage Square Footage | Treasure Valley",
      "Type": "O",
      "AID": 24762,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 75,
          "AID": 24762,
          "APID": 47410,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Detached Garage",
      "Description": "Additional Garage Square Footage | North of Horseshoe Bend",
      "Type": "O",
      "AID": 24763,
      "CategoryID": 53,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 95,
          "AID": 24763,
          "APID": 47411,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Exterior Flatwork",
      "Description": "Exterior Concrete Flatwork is not included in the Home | Falls under homeowner responsibility items",
      "Type": "S",
      "AID": 26505,
      "CategoryID": 56,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Site Work",
      "Description": "Job Site Cleanup Provided by Lexar Homes | Includes final cleaning",
      "Type": "O",
      "AID": 24765,
      "CategoryID": 585,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 6000,
          "AID": 24765,
          "APID": 47371,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Site Work",
      "Description": "Portable Toilet Provided by Lexar Homes-TV",
      "Type": "O",
      "AID": 24766,
      "CategoryID": 585,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 790,
          "AID": 24766,
          "APID": 47372,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Site Work",
      "Description": "Snow Removal Provided by Lexar Homes",
      "Type": "O",
      "AID": 24768,
      "CategoryID": 585,
      "AssemblyPriceTable": [
        {
          "PlanID": 1,
          "Price": 6000,
          "AID": 24768,
          "APID": 47374,
          "Type": false,
          "FID": 39,
          "DateUpdated": "2022-07-27T22:33:50.520Z"
        }
      ],
      "isDummy": false
    },
    {
      "Name": "Site Work",
      "Description": "The customer is responsible for all tasks related to preparing and maintaining the build site. Please refer to the homeowner responsibility sheet.",
      "Type": "S",
      "AID": 26599,
      "CategoryID": 585,
      "AssemblyPriceTable": [],
      "isDummy": false
    },
    {
      "Name": "Appliances",
      "Description": "No Appliances Have Been Included in This Contract | Owner to Source Appliances and Installation After Builder Completes Final Punchlist Items | Check Standard Opening Documents",
      "Type": "S",
      "AID": 24725,
      "CategoryID": 50,
      "AssemblyPriceTable": []
    }
  ]